import React from 'react';
import { Store } from 'pullstate';
import { PuzzleStoreBase } from '../../utils/types';

const OutcomeBanner = ({ store }: { store: Store<PuzzleStoreBase> }) => {
  const { solved, revealed } = store.useState();

  if (solved) {
    return (
      <div className="outcomeBanner solved">
        SOLVED
      </div>
    )
  }

  if (revealed) {
    return (
      <div className="outcomeBanner revealed">
        REVEALED
      </div>
    )
  }

  return null;
};

export default OutcomeBanner;